define(
'shared/initializer/form/adapters/mixins/ActionProvideable',[
    'Promise',
    'shared/util/registers/ActionProvider', 
    'shared/util/dom/observer/remove'
], 
function(
    Promise,
    ActionProvider, 
    removeObserver
) {
    'use strict';

    function Ctor() {
        var me = this;
        me._actionProvidableResolvePromise = null;
        me._actionProvidablePromise = new Promise(function(resolve){
            me._actionProvidableResolvePromise = resolve;
        });
        me._actionProvidableResolved = false;
        me._actionProvidableSubmitScheduled = false;
    }

    Ctor.prototype.doPageLoad = function() {
        var me = this;
        var $form = me.$form;

        var instance = ActionProvider.instance;
        var provider = {
            id: $form.attr('id'),
            $el: $form,
            type: 'form',
            actions: {
                'submit': function(){
                    if (me._actionProvidableResolved) {
                        $form.submit();
                        return;
                    }

                    if (me._actionProvidableSubmitScheduled) {
                        return;
                    }

                    me._actionProvidableSubmitScheduled = true;

                    return me._actionProvidablePromise
                        .then(function(){
                            $form.submit();
                        });
                }
            }
        };
        provider.actions.submit.autoEnable = false;
        instance.register( provider );

        removeObserver($form.parent()[0])
            .then(function(){
                instance.unregister( provider );
            });
        removeObserver($form[0])
            .then(function(){
                instance.unregister( provider );
            });

        return Promise.resolve();
    };

    Ctor.prototype.doAfterPageLoad = function() {
        var me = this;
        me._actionProvidableResolvePromise();
        me._actionProvidableResolved = true;
    };

    return Ctor;
});
